var _path, _path2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWaveGreen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 73,
    viewBox: "0 0 175 73",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.6599 46.8393C17.7076 48.6309 9.98645 46.8164 1 40.3393V72.8394H174V32.3393C164.573 20.4283 164.435 6.28226 149.86 1.83929C133.611 -3.11414 126.356 15.3491 109.628 18.3393C90.2508 21.8031 77.4767 7.23051 59.3372 14.8393C43.3386 21.5501 45.7938 44.0365 28.6599 46.8393Z",
    fill: "url(#paint0_linear_676_1544)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M1 40.3393C9.98645 46.8164 17.7076 48.6309 28.6599 46.8393C45.7938 44.0365 43.3386 21.5501 59.3372 14.8393C77.4767 7.23051 90.2508 21.8031 109.628 18.3393C126.356 15.3491 133.611 -3.11414 149.86 1.83929C164.435 6.28226 164.573 20.4283 174 32.3393",
    stroke: "#478F96"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_676_1544",
    x1: 87.5,
    y1: 12.5,
    x2: 87.5,
    y2: 72.8394,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D0FBFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DDF2F4",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaveGreen);
export default __webpack_public_path__ + "static/media/wave_green.16b6fbf6f92821e0514ad597a4024c90.svg";
export { ForwardRef as ReactComponent };